// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","name":"EditAgentPoolForm__name--OZ","maxAgents":"EditAgentPoolForm__maxAgents--m8","maxAgentsInput":"EditAgentPoolForm__maxAgentsInput--Ik"};